import React from 'react';
import Icon from '../../../components/AppIcon';

export const SOURCE_LABEL = {
  gst: 'From GST records',
  mca: 'From MCA records',
  udyam: 'From Udyam records',
  bank: 'From bank verification',
};

/**
 * A value fetched from a government registry. Read-only by design — the server rejects any
 * attempt to change it — so the input is visibly locked and says where the value came from.
 */
const LockedField = ({ label, value, displayValue, source = 'gst', required = false, description, className = '' }) => {
  const shown = displayValue ?? (value === null || value === undefined ? '' : String(value));
  return (
    <div className={`space-y-2 ${className}`}>
      <label className="text-sm font-medium leading-none text-foreground">
        {label} {required && <span className="text-destructive ml-1">*</span>}
      </label>
      <div className="relative">
        <input
          type="text"
          value={shown}
          readOnly
          aria-readonly="true"
          tabIndex={-1}
          className="flex h-10 w-full cursor-default rounded-md border border-success/30 bg-success/5 pl-3 pr-10 py-2 text-sm text-foreground shadow-sm focus-visible:outline-none"
        />
        <span className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-success" aria-hidden="true">
          <Icon name="ShieldCheck" size={16} />
        </span>
      </div>
      <p className="flex items-center gap-1.5 text-xs text-text-secondary">
        <Icon name="Lock" size={12} className="text-success" />
        {description || SOURCE_LABEL[source] || 'From verified records'}
      </p>
    </div>
  );
};

export default LockedField;
